import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoDesembolso } from '../../../_models/producto-desembolso';
import { Router } from '@angular/router';
import { FormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { ProductoDesembolsoService } from '../../../_services/producto-desembolso.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../_services/_nav.service';

@Component( {
  selector: 'app-producto-desembolso-editar',
  templateUrl: 'producto-desembolso-editar.component.html'
} )
export class ProductoDesembolsoEditarComponent implements OnInit {

  // Input Output
  @Input()
  productoDesembolso: ProductoDesembolso;

  @Input()
  rangoMontoAprobado: any[] = [];

  @Output()
  dismiss: EventEmitter<boolean> = new EventEmitter();

  // Config
  formulario: FormGroup;
  submitted = false;
  rangoInvalido = false;

  rangoMontoAprobadoValido = false;
  rangoPlazoAprobadoValido = false;
  diaCantidadDesembolsoParcialValido = false;
  rangoAmpliarPlazoMaximoDia = false;


  constructor(
    private productoDesembolsoService: ProductoDesembolsoService,
    private router: Router,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private navServicio: NavService,
  ) {
  }


  ngOnInit(): void {
    this.cargarFormulario();
  }


  get f() {
    return this.formulario.controls;
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoDesembolso: [ this.productoDesembolso ? this.productoDesembolso.idProductoDesembolso : null ],
      idProducto: [ this.productoDesembolso ? this.productoDesembolso.idProducto : null, [ Validators.required ] ],
      rangoMontoAprobadoMinimo: new UntypedFormControl( {
        value: this.productoDesembolso ? this.productoDesembolso.rangoMontoAprobadoMinimo : null,
        disabled: this.productoDesembolso ? !!this.productoDesembolso.rangoMontoAprobadoMinimo : false
      }, [ Validators.required ] ),
      rangoMontoAprobadoMaximo: [ this.productoDesembolso ? this.productoDesembolso.rangoMontoAprobadoMaximo : null, [ Validators.required ] ],
      rangoPlazoAprobadoMinimo: [ this.productoDesembolso ? this.productoDesembolso.rangoPlazoAprobadoMinimo : null, [ Validators.required ] ],
      rangoPlazoAprobadoMaximo: [ this.productoDesembolso ? this.productoDesembolso.rangoPlazoAprobadoMaximo : null, [ Validators.required ] ],
      rangoTasaProductoOrdinario: [ this.productoDesembolso ? this.productoDesembolso.rangoTasaProductoOrdinario : null, [ Validators.required ] ],
      rangoTasaProductoMinimo: [ this.productoDesembolso ? this.productoDesembolso.rangoTasaProductoMinimo : null, [ Validators.required ] ],
      limiteDiaDesembolso: [ this.productoDesembolso ? this.productoDesembolso.limiteDiaDesembolso : null, [ Validators.required ] ],
      minimoDiaCantidadDesembolsoParcial: [ this.productoDesembolso ? this.productoDesembolso.minimoDiaCantidadDesembolsoParcial : null, [ Validators.required ] ],
      maximoDiaCantidadDesembolsoParcial: [ this.productoDesembolso ? this.productoDesembolso.maximoDiaCantidadDesembolsoParcial : null, [ Validators.required ] ],
      rangoAmpliarPlazoMinimoDia: [ this.productoDesembolso ? this.productoDesembolso.rangoAmpliarPlazoMinimoDia : null, [ Validators.required ] ],
      rangoAmpliarPlazoMaximoDia: [ this.productoDesembolso ? this.productoDesembolso.rangoAmpliarPlazoMaximoDia : null, [ Validators.required ] ],
      ampliarPlazo: [ this.productoDesembolso ? this.productoDesembolso.ampliarPlazo : null, [ Validators.required ] ],
      diaMaximoMoraCliente: [ this.productoDesembolso ? this.productoDesembolso.diaMaximoMoraCliente : null, [ Validators.required ] ],
      diaMaximoMoraProducto: [ this.productoDesembolso ? this.productoDesembolso.diaMaximoMoraProducto : null, [ Validators.required ] ]
    } )
    ;
  }


  guardar() {
    this.submitted = true;
    this.rangoInvalido = this.validarRango();
    this.validarRangos();
    if ( this.formulario.valid && this.esValidoTodosLosRangos() && !this.rangoInvalido ) {
      if ( this.productoDesembolso === undefined || this.productoDesembolso == null ) {
        this.productoDesembolsoService.crear( this.formulario.getRawValue() )
          .subscribe( () => this.dismiss.emit( true ) );
      } else {
        this.productoDesembolsoService.actualizar( this.formulario.getRawValue() )
          .subscribe( () => this.dismiss.emit( true ) );
      }
    }
  }

  private validarRangos() {
    this.rangoMontoAprobadoValido = Number( this.f.rangoMontoAprobadoMaximo.value ) >= Number( this.f.rangoMontoAprobadoMinimo.value );
    this.rangoPlazoAprobadoValido = Number( this.f.rangoPlazoAprobadoMaximo.value ) >= Number( this.f.rangoPlazoAprobadoMinimo.value );
    this.diaCantidadDesembolsoParcialValido = Number( this.f.maximoDiaCantidadDesembolsoParcial.value ) >= Number( this.f.minimoDiaCantidadDesembolsoParcial.value );
    this.rangoAmpliarPlazoMaximoDia = Number( this.f.rangoAmpliarPlazoMaximoDia.value ) >= Number( this.f.rangoAmpliarPlazoMinimoDia.value );
  }

  private esValidoTodosLosRangos() {
    return this.rangoMontoAprobadoValido && this.rangoPlazoAprobadoValido && this.diaCantidadDesembolsoParcialValido && this.rangoAmpliarPlazoMaximoDia;
  }

  regresar() {
    if ( this.formulario.dirty ) {
      this.confirmationService.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'desembolso',
        icon: 'fa fa-question-circle',
        accept: () => this.dismiss.emit( false ),
        reject: () => {
        }
      } );
    } else {
      this.dismiss.emit( false );
    }
  }

  // false = rango válido
  validarRango(): boolean {
    if ( this.rangoMontoAprobado.length === 0 ) {
      return false;
    }
    const diaMin = Number( this.f.rangoMontoAprobadoMinimo.value );
    const diaMax = Number( this.f.rangoMontoAprobadoMaximo.value );
    let interseccion = false;

    for ( const item of this.rangoMontoAprobado ) {
      if ( !(diaMin >= item.maximo || diaMax <= item.minimo) ) {
        interseccion = true;
        return interseccion;
      }
    }
    return interseccion;
  }

}
